import themes from 'daisyui/src/theming/themes.js';

import { ConfigProps } from './types/config';

const config = {
  // REQUIRED
  appName: "AIToolly",
  appTitle: "Best AI Tools Directory 2026-AIToolly",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "Find the Best AI Tools and Apps with AIToolly.com",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "aitoolly.com",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (mailgun.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  stripe: {
    // Stripe one-time payment plans (migrated from subscription model)
    // Create one-time payment prices in your Stripe dashboard, then add them here
    plans: [
      {
        planCode: "listing",
        priceId: process.env.NEXT_PUBLIC_STRIPE_LISTING_PRICE_ID || "price_listing_2999_not_configured",
        isFeatured: false,
        includesVideo: false,
        name: "Directory Listing",
        shortName: "Listing",
        description: "A focused directory launch for founders who already have their own creative assets.",
        price: 29.99,
        originalPrice: 49.99,
        deliveryDays: 1,
        features: [
          { name: "Priority review by the next business day" },
          { name: "Permanent AIToolly product page" },
          { name: "Featured placement for 7 days" },
          { name: "Domain Search access" },
        ],
      },
      {
        planCode: "video_launch",
        priceId: process.env.NEXT_PUBLIC_STRIPE_VIDEO_PRICE_ID || "price_video_launch_4999_not_configured",
        isFeatured: true,
        includesVideo: true,
        name: "Video Launch Pack",
        shortName: "Listing + Video",
        description: "Turn one submitted URL into a published launch video and a reusable commercial asset.",
        price: 49.99,
        originalPrice: 69.99,
        deliveryDays: 3,
        features: [
          { name: "Everything in Directory Listing" },
          { name: "45-75 second English launch video" },
          { name: "1080p widescreen production" },
          { name: "Automatic publishing to YouTube and X" },
          { name: "Product page + dedicated watch page" },
          { name: "MP4 download with commercial usage rights" },
          { name: "Fully automatic, no revisions" },
        ],
      },
    ],
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  mailgun: {
    // subdomain to use when sending emails, if you don't have a subdomain, just remove it. Highly recommended to have one (i.e. mg.yourdomain.com or mail.yourdomain.com)
    subdomain: "mg",
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `AIToolly <support@aitoolly.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Andy at AIToolly <support@aitoolly.com>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "support@AIToolly.com",
    // When someone replies to supportEmail sent by the app, forward it to the email below (otherwise it's lost). If you set supportEmail to empty, this will be ignored.
    forwardRepliesTo: "support@AIToolly.com",
  },
  colors: {
    // REQUIRED — The DaisyUI theme to use (added to the main layout.js). Leave blank for default (light & dark mode). If you any other theme than light/dark, you need to add it in config.tailwind.js in daisyui.themes.
    theme: "light",
    // REQUIRED — This color will be reflected on the whole app outside of the document (loading bar, Chrome tabs, etc..). By default it takes the primary color from your DaisyUI theme (make sure to update your the theme name after "data-theme=")
    // OR you can just do this to use a custom color: main: "#f37055". HEX only.
    main: themes[`[data-theme=light]`]["primary"],
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
  sponsorBanner: {
    // Top sponsor banner configuration (shown on all pages)
    enabled: true,
    sponsorName: "AriaFlow.ai",
    text: "Create faceless videos, storybooks, and podcasts with AI workflows that can auto-publish for you.",
    link: "https://ariaflow.ai/?utm_source=aitoolly.com&utm_medium=referral&utm_campaign=sponsor_banner",
    linkText: "Start Free",
    logo: "https://favicon.im/ariaflow.ai",
  },
  lemonsqueezy: {
    // DEPRECATED: Lemon Squeezy configuration kept for historical order queries only
    // The payment system has been migrated to Stripe for one-time payments
    // See stripe.plans above for current payment configuration
    // This configuration is preserved to support existing Lemon Squeezy orders
    plans: [],
  },
} as ConfigProps;

export default config;
